import React from "react";

function ErrorPage() {
  return <div>Error Page. Nothing here.</div>;
}

export default ErrorPage;
